var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNewTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 27,
    viewBox: "0 0 59 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5C0 6.04416 6.04416 0 13.5 0H45.5C52.9558 0 59 6.04416 59 13.5V13.5C59 20.9558 52.9558 27 45.5 27H13.5C6.04415 27 0 20.9558 0 13.5V13.5Z",
    fill: "#FF6262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3535 18H22.0713L17.4121 11.2842H17.3359V18H15.9395V8.80859H17.2344L21.8936 15.5371H21.9824V8.80859H23.3535V18ZM25.1024 8.80859H30.8661V10.0146H26.4989V12.7949H30.5614V13.9883H26.4989V16.7939H30.9169V18H25.1024V8.80859ZM31.7136 8.80859H33.1863L34.9763 15.918H35.0525L36.9187 8.80859H38.366L40.2322 15.918H40.3084L42.0984 8.80859H43.5711L41.0193 18H39.6101L37.6804 11.1318H37.6043L35.6746 18H34.2654L31.7136 8.80859Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewTag);
export default __webpack_public_path__ + "static/media/ic_new_tag.08df3beb171ba93356ff4f674d20770c.svg";
export { ForwardRef as ReactComponent };